"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactPaginate = _interopRequireDefault(require("react-paginate"));
var _arrow = _interopRequireDefault(require("./images/arrow.svg"));
var _excluded = ["pageRangeDisplayed", "marginPagesDisplayed"];
var Pagination = exports.Pagination = function Pagination(_ref) {
  var _ref$pageRangeDisplay = _ref.pageRangeDisplayed,
    pageRangeDisplayed = _ref$pageRangeDisplay === void 0 ? 5 : _ref$pageRangeDisplay,
    _ref$marginPagesDispl = _ref.marginPagesDisplayed,
    marginPagesDisplayed = _ref$marginPagesDispl === void 0 ? 2 : _ref$marginPagesDispl,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactPaginate["default"], (0, _extends2["default"])({}, restProps, {
    pageRangeDisplayed: pageRangeDisplayed,
    marginPagesDisplayed: marginPagesDisplayed,
    containerClassName: "pagination",
    pageClassName: "pagination__item",
    previousClassName: "pagination__item",
    nextClassName: "pagination__item",
    breakClassName: "pagination__item pagination__break",
    pageLinkClassName: "pagination__item-link",
    previousLinkClassName: "pagination__item-link",
    nextLinkClassName: "pagination__item-link",
    breakLinkClassName: "pagination__item-link",
    activeLinkClassName: "pagination__item-link_active",
    previousLabel: /*#__PURE__*/_react["default"].createElement("img", {
      src: _arrow["default"],
      width: 9,
      height: 14,
      className: "pagination__arrow-icon",
      alt: ""
    }),
    nextLabel: /*#__PURE__*/_react["default"].createElement("img", {
      src: _arrow["default"],
      width: 9,
      height: 14,
      className: "pagination__arrow-icon pagination__arrow-icon_next",
      alt: ""
    })
  }));
};